import "./NavBar.scss";

function NavBar() {
  return (
    <div class="nav_container">
      <a href="/"> Home </a>
      <a href="/unsubscribe"> Unsubscribe </a>
    </div>
  )
}

export default NavBar;